import styled from 'styled-components/macro';

import { colors } from 'styles/colors';
import { device } from 'styles/device';
import { fontSizes, fontStyles } from 'styles/fonts';

export const CommonCardWrapper = styled.div`
	flex: 0 0 calc(20% - 20px);
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	margin: 0 0 20px 20px;
	width: 40%;
	background: ${colors.gradient};
	cursor: pointer;
	transition: transform 0.15s linear;
	flex-direction: column;

	&:hover {
		box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
		transform: translateY(-5px);
	}

	@media ${device.laptopL} {
		flex: 0 0 calc(25% - 20px);
	}

	@media ${device.tablet} {
		flex: 0 0 calc(33.33% - 20px);
	}

	@media ${device.mobileL} {
		flex: 0 1 100%;
		min-height: 100%;
		max-width: 43%;
	}
`;

export const CommonCard = styled.div`
	background: ${colors.white};
	width: calc(100% - 2px);
	height: calc(100% - 2px);
	border-radius: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 1px;
`;

export const CommonCardGeneralInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	object-fit: cover;
	margin: 25px 0 10px 0;
`;

export const CommonCardIcon = styled.img`
	height: 54px;
	width: 54px;
	@media ${device.mobileL} {
		height: 46px;
		width: 38px;
		margin-top: 20px;
	}
`;

export const CommonCardTitle = styled.div`
	font-weight: 600;
	${fontStyles[fontSizes.eighteen]};
	text-align: center;
	word-break: break-word;
	padding: 5px;
`;

export const CommonCardDescription = styled.div`
	margin: 0 10px 20px 10px;
	text-align: center;
	color: ${colors.darkGrey};
`;

export const CommonCardDate = styled.div`
	color: ${colors.darkGrey};
	font-weight: 900;
	font-size: 14px;
	line-height: 19px;
`;
